import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/Viki2.jpg";
import IMG2 from "../../assets/Viki3.png";
import IMG3 from "../../assets/Viki19.jpeg";
import IMG4 from "../../assets/Viki5.png";
import IMG5 from "../../assets/Viki16.jpeg";
import IMG6 from "../../assets/Viki13.jpeg";

const data = [
  {
    id: 1,
    image: IMG1,
    title: "Producción MDZ Vendimia",

  },
  {
    id: 2,
    image: IMG2,
    title: "Producción 2020 | Bodega Susana Balbo",

  },
  {
    id: 3,
    image: IMG3,
    title: "Natalia Baigorria | Hotel Hyatt Mendoza | Wedding Planner",

  },

  //Natalia Baigorria Wedding Planner - Hotel Hyatt Mendoza
  {
    id: 4,
    image: IMG4,
    title: "Evento de Novias 2019 | Hotel Intercontinental",

  },

  {
    id: 5,
    image: IMG5,
    title: "Destination Wedding | Boda de Destino | Hotel Valle de Uco",

  },
  // Boda de destino Valle de Uco - Hotel Valle de Uco
  // Natalia Baigorria Wedding Planner
  {
    id: 6,
    image: IMG6,
    title: "Producción de fotos para Ricky Videla | Hotel Hyatt Mendoza",
  },

  //Produccion de fotos para Ricky Videla Producciones - Hotel Hyatt Mendoza
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>Mis ultimos trabajos</h5>
      <h2>Portafolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
